import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import React from 'react';
import { TypistSpeedControl } from './Typist';

const useStyles = makeStyles((theme) => ({
  speedControlContainer: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    paddingRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
    background: `linear-gradient(rgba(255, 255, 255, 0.01) 0%, ${theme.palette.background.default} 20%)`,
  },
  speedControl: {
    '& label': {
      transform: 'translate(0, 50%) scale(0.75)',
      transformOrigin: 'bottom right',
      bottom: '55%',
      right: '110%',
      top: 'auto',
      left: 'auto',
      width: '8.5rem',
    },
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
  },
  supportLink: {
    '& > svg': {
      verticalAlign: 'middle',
    },
    '& span': {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  },
}));

export default function Layout({ children }: { children: React.ReactNode }) {
  const classes = useStyles();
  return (
    <Box flex={1} flexDirection="column" display="flex" paddingBottom={7}>
      {children}
      <Box className={classes.speedControlContainer}>
        <Link href="mailto:report@matildaexp.com" className={classes.supportLink}>
          <ContactSupportIcon />
          <span>Questions or comments?</span>
        </Link>
        <TypistSpeedControl className={classes.speedControl} />
      </Box>
    </Box>
  );
}
